import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import { CustomizeHttpUrlGenerator } from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import { TreatmentFeedbackModel } from '../../../api/models/treatment-feedback.model';
import { TreatmentFeedbackConverter } from '../../../api/models/converter/treatment-feedback.converter';

@Injectable()
export class TreatmentFeedbackDataService extends AbstractDataServiceV2<TreatmentFeedbackModel, TreatmentFeedbackConverter> {
    constructor(http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: TreatmentFeedbackConverter) {
        super('TreatmentFeedback', http, httpUrlGenerator, logger, config, converter);
    }
}